import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_arrow_right",
  "use": "icon-ic_arrow_right-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_arrow_right\">\n<g id=\"icon-ic_arrow_right_ic_arrow_right\">\n<path id=\"icon-ic_arrow_right_Vector\" d=\"M7.23746 6L3.34839 2.11088L4.05549 1.40378L8.29816 5.64644C8.49342 5.84171 8.49342 6.15829 8.29816 6.35355L4.05549 10.5962L3.34839 9.88908L7.23746 6Z\" fill=\"#C6C6C6\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol